module.exports = __webpack_public_path__ + "static/media/robograf.addec99e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robograf.png
// module id = 349
// module chunks = 0